module.exports = __webpack_public_path__ + "img/feature-illustration-3.601bae2.svg";